<template>
  <div class="mt-4">
    <div class="confirmation-name mb-2">
      <h4 class="checkout-h4">Você pagou com PIX</h4>
      <div class="confirmation-name__icons">
        <v-row no-gutters justify="space-between" class="mt-2" align="center">
          <h3
            class="checkout-h3"
            :class="
              finalDetails.status === 'paid' && !isWaitingApproval
                ? 'success--text'
                : 'atention--text'
            "
          >
            {{
              isWaitingApproval
                ? "Aguardando aprovação"
                : finalDetails.status === "paid"
                ? $t("finished.pix.approved")
                : finalDetails.status
            }}
          </h3>
          <svg
            class="ml-2"
            v-if="finalDetails.status === 'paid'"
            style="width: 24px; height: 24px"
            viewBox="0 0 24 24"
          >
            <path
              fill="#00a65a"
              d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
            />
          </svg>

          <v-icon class="ml-2" v-else color="atention"
            >mdi-alert-circle-outline</v-icon
          >
        </v-row>
      </div>
    </div>
    <p
      v-if="$route.query.order_hash && orderDetails"
      class="grey--text checkout-h5"
    >
      {{ $t("finished.pix.orderValue")
      }}{{ orderDetails.valor_pendente | currency }}
    </p>
    <p v-else class="grey--text checkout-h5">
      {{ $t("finished.pix.orderValue") }}{{ productsTotal | currency }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters([
      "finalDetails",
      "orderDetails",
      "productsTotal",
      "cartProducts",
    ]),

    isWaitingApproval() {
      return this.finalDetails?.orderStatus === "W";
    },
  },
};
</script>
